import { AccountTopupConfirmationManager } from '../AccountTopupConfirmationManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class AccountTopupConfirmationManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/account/topup/confirmation`,
      headers
    );
  }

  createAccountTopupConfirmationManager(token: string): AccountTopupConfirmationManager {
    return new AccountTopupConfirmationManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
